var lastTime = new Date().getTime();
var currentTime = new Date().getTime();
var timeOut = 60 * 60 * 1000; //设置超时时间： 30分

window.onload = function () {
    window.document.onmousedown = function () {
        sessionStorage.setItem("lastTime",new Date().getTime());
    }
};
function checkTimeout() {
    currentTime = new Date().getTime(); //更新当前时间
    lastTime = sessionStorage.getItem("lastTime");
    // console.log(currentTime - lastTime);
    // console.log(timeOut);
    if (currentTime - lastTime > timeOut) { //判断是否超时
        // console.log("超时");
        var url = window.location.href;
        var newUrl=url.match(/(\S*)#/)[1];
        sessionStorage.removeItem("token");
        window.open(newUrl + '#/login','_self');
    }
}

/* 定时器 间隔30秒检测是否长时间未操作页面 */
window.setInterval(checkTimeout, 10000);
console.log(window.screen.width+"*****************8")
if (window.screen.width < 1152)
    document.write ('<body style="zoom: 50%">');
else if (window.screen.width > 1151 && window.screen.width <1280)
    document.write ('<body style="zoom: 57%">');
else if (window.screen.width > 1279 && window.screen.width < 1336)
    document.write ('<body style="zoom: 62.5%">');
else if (window.screen.width > 1335 && window.screen.width < 1440)
    document.write ('<body style="zoom: 67%">');
else if (window.screen.width >= 1440 && window.screen.width < 1536)
    document.write ('<body style="zoom: 71%">');
else if (window.screen.width >= 1536 && window.screen.width < 1680)
    document.write ('<body style="zoom: 76%">');
else if (window.screen.width >= 1680 && window.screen.width < 1920)
    document.write ('<body style="zoom: 83%">');
else if (window.screen.width >= 1920)
    document.write ('<body style="zoom: 95%">');
